// extracted by mini-css-extract-plugin
export default {"image":"gY-z","loaded":"hY-z"};